
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uk/accessibility",
      function () {
        return require("private-next-pages/uk/accessibility.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/uk/accessibility"])
      });
    }
  